module.exports = __webpack_public_path__ + "img/ship.602be0d.svg";